import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C1C7CD",
      d: "M17 10a7 7 0 1 0-14 0 7 7 0 0 0 14 0Zm-7.5 3.333V9.167a.5.5 0 0 1 1 0v4.166a.5.5 0 1 1-1 0ZM18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7.459-3.25a.5.5 0 0 1-.498.5H9.96a.501.501 0 0 1-.502-.5v-.083a.5.5 0 0 1 .5-.5h.083a.5.5 0 0 1 .5.5v.083Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Info"}) } }